import { Mark, mergeAttributes } from '@tiptap/core';
export const HighlightColor = Mark.create({
    name: 'highlightColor',
    clearable: false,
    inclusive: false,
    addOptions() {
        return {
            types: ['textStyle'],
            HTMLAttributes: {},
        };
    },
    addAttributes() {
        return {
            color: {
                default: null,
                parseHTML: (element) => element.getAttribute('data-color'),
                renderHTML: (attributes) => {
                    if (!attributes.color) {
                        return {};
                    }
                    return {
                        'data-color': attributes.color,
                        style: `background-color: ${attributes.color};`,
                    };
                },
            },
            commentId: {
                default: null,
                parseHTML: (element) => element.getAttribute('data-comment-id'),
                renderHTML: (attributes) => {
                    if (attributes.commentId === null || attributes.commentId === undefined) {
                        return {};
                    }
                    return {
                        'data-comment-id': String(attributes.commentId),
                    };
                },
            },
            suggestionId: {
                default: null,
                parseHTML: (element) => element.getAttribute('data-suggestion-id'),
                renderHTML: (attributes) => {
                    if (attributes.suggestionId === null || attributes.suggestionId === undefined) {
                        return {};
                    }
                    return {
                        'data-suggestion-id': String(attributes.suggestionId),
                    };
                },
            },
            searchHighlight: {
                default: null,
                parseHTML: (element) => element.getAttribute('data-search-highlight'),
                renderHTML: (attributes) => {
                    if (attributes.searchHighlight === null || attributes.searchHighlight === undefined) {
                        return {};
                    }
                    return {
                        'data-search-highlight': String(attributes.searchHighlight),
                    };
                },
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'mark',
                getAttrs: (node) => {
                    if (typeof node === 'string') {
                        return false;
                    }
                    const element = node;
                    const color = element.getAttribute('data-color');
                    if (!color) {
                        return false;
                    }
                    return { color };
                },
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [
            'mark',
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
            0,
        ];
    },
    addCommands() {
        return {
            setHighlightColor: (attributes) => ({ commands }) => {
                return commands.setMark(this.name, attributes);
            },
            toggleHighlightColor: (attributes) => ({ commands }) => {
                return commands.toggleMark(this.name, attributes);
            },
            unsetHighlightColor: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
});
//# sourceMappingURL=highlight-color.js.map